@if (resultingSvg) {
<div class="icon-container" [innerHTML]="resultingSvg"></div>
}
